import { useState } from 'react';
import { initiateOAuthLogin } from '../services/oauthService';

function OAuthButton({ provider, label, icon }) {
  const [isStarting, setIsStarting] = useState(false);
  const [error, setError] = useState('');

  // Starting the flow is a request now, not a plain navigation (see
  // oauthService), so it can fail before the user ever reaches Google.
  const handleClick = async () => {
    setError('');
    setIsStarting(true);
    try {
      await initiateOAuthLogin(provider);
      // On success the browser is navigating away; leave the button disabled.
    } catch (err) {
      console.log('OAuth start error:', err);
      setError('Could not start sign-in. Please try again.');
      setIsStarting(false);
    }
  };

  return (
    <>
      {/* Matches the primary button on /login and /signup - gold, pill, same
          hover lift - so the OAuth and password paths read as two routes to
          the same place rather than one real button and one secondary thing.
          The logo keeps its white disc: Google's mark is drawn to sit on
          white, and on gold it loses the blue/green entirely. */}
      <button
        type="button"
        onClick={handleClick}
        disabled={isStarting}
        className="w-full flex items-center justify-center px-4 py-2 rounded-full bg-nlg-gold font-bold transition-transform duration-150 hover:scale-[1.02] disabled:opacity-60 disabled:hover:scale-100"
      >
        <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center mr-3 flex-shrink-0">
          <img src={icon} alt={provider} className="w-5 h-5" />
        </div>
        <span className="text-nlg-bg">
          {isStarting ? 'Connecting…' : label}
        </span>
      </button>

      {error && (
        <div className="bg-nlg-coral/10 border border-nlg-coral/30 text-nlg-coral px-3 py-2 rounded-lg text-sm text-center" role="alert">
          {error}
        </div>
      )}
    </>
  );
}

export default OAuthButton;
